import Vue from 'vue';

import AppButton from '@/app/core/components/app-button';
import AppInputDate from '@/app/core/components/app-input-date';
import AppInputGroup from '@/app/core/components/app-input-group';
import AppLogo from '@/app/core/components/app-logo';
import AppOverview from '@/app/core/components/app-overview';
import AppRadioButtons from '@/app/core/components/app-radio-buttons';
import AppRadioButtonsTooltips from '@/app/core/components/app-radio-buttons-tooltips';
import AppCheckboxGroup from '@/app/core/components/app-checkbox-group';
import AppSelectGroup from '@/app/core/components/app-select-group';
import AppStepper from '@/app/core/components/app-stepper';
import AppSvgIcon from '@/app/core/components/app-svg-icon';
import AppTooltip from '@/app/core/components/app-tooltip';
import AppDataTable from '@/app/core/components/app-data-table';
import AppRightSidebar from '@/app/core/components/app-right-sidebar';
import AppInfoBlock from '@/app/core/components/app-info-block';
import AppLoader from '@/app/core/components/app-loader';
import AppDetailsSidebar from '@/app/core/components/app-details-sidebar';
import AppDeleteDialog from '@/app/core/components/app-delete-dialog';
import AppCurrencyInput from '@/app/core/components/app-currency-input';
import AppInputFile from '@/app/core/components/app-input-file';
import AppResolution from '@/app/core/components/app-resolution';
import AppPasswordField from '@/app/core/components/app-password-field';
import AppAuthMessage from '@/app/core/components/app-auth-message';
import AppAuthLoader from '@/app/core/components/app-auth-loader';
import AppHelp from '@/app/core/components/app-help';
import AppDownloadButton from '@/app/core/components/app-download-button';
import AppInfoDialog from '@/app/core/components/app-info-dialog';
import AppAutocomplete from '@/app/core/components/app-autocomplete';
import AppBaseDialog from '@/app/core/components/app-base-dialog';
import AppDropdown from '@/app/core/components/app-dropdown';
import AppTabs from '@/app/core/components/app-tabs';
import AppBreadcrumbs from '@/app/core/components/app-breadcrumbs';
import AppInfoTable from '@/app/core/components/app-info-table';
import AppAgentAvatar from '@/app/core/components/app-agent-avatar';
import AppFilesForm from '@/app/core/components/app-files-form';
import AppIframeDialog from '@/app/core/components/app-iframe-dialog';
import AppErrorsDialog from '@/app/core/components/app-errors-dialog';
import AppInfoLoader from '@/app/core/components/app-info-loader';

Vue.component('AppButton', AppButton);
Vue.component('AppInputDate', AppInputDate);
Vue.component('AppInputGroup', AppInputGroup);
Vue.component('AppLogo', AppLogo);
Vue.component('AppOverview', AppOverview);
Vue.component('AppRadioButtons', AppRadioButtons);
Vue.component('AppRadioButtonsTooltips', AppRadioButtonsTooltips);
Vue.component('AppCheckboxGroup', AppCheckboxGroup);
Vue.component('AppSelectGroup', AppSelectGroup);
Vue.component('AppStepper', AppStepper);
Vue.component('AppSvgIcon', AppSvgIcon);
Vue.component('AppTooltip', AppTooltip);
Vue.component('AppDataTable', AppDataTable);
Vue.component('AppRightSidebar', AppRightSidebar);
Vue.component('AppInfoBlock', AppInfoBlock);
Vue.component('AppLoader', AppLoader);
Vue.component('AppDetailsSidebar', AppDetailsSidebar);
Vue.component('AppDeleteDialog', AppDeleteDialog);
Vue.component('AppCurrencyInput', AppCurrencyInput);
Vue.component('AppInputFile', AppInputFile);
Vue.component('AppInputFile', AppInputFile);
Vue.component('AppResolution', AppResolution);
Vue.component('AppPasswordField', AppPasswordField);
Vue.component('AppAuthMessage', AppAuthMessage);
Vue.component('AppAuthLoader', AppAuthLoader);
Vue.component('AppHelp', AppHelp);
Vue.component('AppDownloadButton', AppDownloadButton);
Vue.component('AppInfoDialog', AppInfoDialog);
Vue.component('AppAutocomplete', AppAutocomplete);
Vue.component('AppBaseDialog', AppBaseDialog);
Vue.component('AppDropdown', AppDropdown);
Vue.component('AppTabs', AppTabs);
Vue.component('AppBreadcrumbs', AppBreadcrumbs);
Vue.component('AppInfoTable', AppInfoTable);
Vue.component('AppAgentAvatar', AppAgentAvatar);
Vue.component('AppFilesForm', AppFilesForm);
Vue.component('AppIframeDialog', AppIframeDialog);
Vue.component('AppErrorsDialog', AppErrorsDialog);
Vue.component('AppInfoLoader', AppInfoLoader);
